<template>

    <div>
        <div class="header page-header">
            <div>CUSTOMERS</div>
            <p>New customer</p>
        </div>
        <div class="card">
            <div class="form">
                <div class="form__group form__group--spaced">
                    <label>Phone <span style="color: #ff5e5e;">*</span> </label>
                    <input class="input input__round" v-bind:class="{err: errors.address}"
                           style="width: 100%; max-width: 350px" type="number" v-model="customer.phone"
                           placeholder="Specify phone number"/>
                    <span class="form__error" v-if="errors.phone">
                        {{Array.isArray(errors.phone) ? errors.phone[0]: errors.phone}}
                    </span>

                </div>
                <div class="form__group form__group--spaced">
                    <label>Name</label>
                    <input class="input input__round" v-bind:class="{err: errors.name}"
                           style="width: 100%; max-width: 350px" v-model="customer.name"
                           placeholder="James Doe"/>
                    <span class="form__error" v-if="errors.name">
                        {{Array.isArray(errors.name) ? errors.name[0]: errors.name}}
                    </span>
                </div>
                <div class="form__group form__group--spaced">
                    <label>Customer Address</label>
                    <input class="input input__round" v-bind:class="{err: errors.address}"
                           style="width: 100%; max-width: 350px" v-model="customer.address"
                           placeholder="Address here"/>
                    <span class="form__error" v-if="errors.address">
                        {{Array.isArray(errors.address) ? errors.address[0]: errors.address}}
                    </span>

                </div>
            </div>
            <div class="form__actions">
                <Button text="Save" class="btn btn__primary" style="margin-left: auto; display: block"
                        @on-click="createCustomer" :loading='loading'/>
            </div>
        </div>
    </div>
</template>
<script>
  import Button from '../partials/Button.vue'
  import * as api from './api.js'
  import * as validation from './validations.js'

  const INITIAL_CUSTOMER = {
    name: '',
    phone: '',
    address: ''
  }
  export default {
    name: "CreateCustomer",
    components: {
      Button
    },
    created: async function() {
      document.title = 'Add Customer | PayGate Invoice'
    },
    methods: {
      createCustomer: async function () {
        let response
        this.error = ''
        this.errors = {}
        const { errors, isValid } = validation.customer(this.customer)
        if (!isValid) {
          this.errors = errors
          console.log(this.errors)
          return
        }
        this.loading = true

        try {
          this.errors = {}
          response = await api.createCustomer(this.customer)
          this.customer = INITIAL_CUSTOMER
          this.loading = false
          this.$toasted.success(
            "Customer added successfully",
            { className: "success-toast" }
          );
          this.$router.push('/dashboard/customers')
        } catch (e) {
          this.loading = false
          let err_msg = 'Something went wrong'
          Object.keys(e.response.data.errors).map(key => err_msg = e.response.data.errors[key][0])
          this.$toasted.error(
            err_msg,
            { className: "error-toast" }
          )
          this.errors = e.response.data.errors
        }
      },

    },
    data () {
      return {
        customer: INITIAL_CUSTOMER,
        error: '',
        errors: {},
        loading: false
      }
    }
  }
</script>

<style lang="scss" scoped>
    .button-container {
        display: flex;
        justify-content: flex-end
    }

</style>
